<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div class="border-box">
        <div class="inner-box">
            <BBtnRadio
                v-model="signList"
                @input="clickSignPeriod"
                style="margin: 12px 0;"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBtnRadio from "../../components2/BBtnRadio";

export default {
  name: "SignSelect",
  props: {
    data: Object,
    confirmEvent: Boolean,
  },
  components: {
    BBtnRadio,
  },
  watch: {
    // 点击确定按钮 调用save方法
    confirmEvent() {
      if (this.confirmEvent === true) {
        this.$router.push({
          name: "class_student_sign_list",
          params: { classId: this.classId ,signPeriod:this.signPeriod,status:this.status},
        })
      }
      this.$emit("input", false);
    },
  },
  data() {
    return {
      returnData: "",
      signList: {
         
      },
      classId: [],
      signPeriod:"",
      status:'',
    };
  },
  created() {
    if (
      this.data.signList !== null &&
      this.data.signList !== "" &&
      this.data.signList !== undefined 
    ) {
      this.signList = this.data.signList;
    }
    if(this.data.classId !== null &&
      this.data.classId !== "" &&
      this.data.classId !== undefined
      ){
      this.classId = this.data.classId
    }
    if(this.data.status !== null &&
      this.data.status !== "" &&
      this.data.status !== undefined
      ){
      this.status = this.data.status
    }
    this.clickSignPeriod(this.signList)
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    clickSignPeriod(data){
        this.signPeriod = ""
        for(let i = 0; i < data.data.length; i++){
            if(data.checked === data.data[i].value){
                this.signPeriod = data.data[i].label
            }
        }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.border-box {
  display: flex;
  width: 400px;
  height: 100px;
  /*margin: 30px 0 30px 0;*/
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}
</style>